import React, { useEffect } from 'react'
import {
  Button,
  DialogActions,
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { makeStyles } from '@material-ui/styles'

import ButtonSubmit from '../../common/ButtonSubmit'
import { publishViewed } from '../../../util/events/teamsGiftsEventPublishers'
import { VIEWS } from '../../../util/events/teamsEvents'
import { formatCentsToPrettyDollars, getAmountPer } from './giftCardUtils'
import DialogContent from './DialogContent'

const useStyles = makeStyles({
  bold: {
    fontWeight: 'bold',
  },
})

const StepGiftPayment = ({ actionableMembers, values, submitting, error, onBack }) => {
  const classes = useStyles()

  useEffect(() => {
    publishViewed(VIEWS.STEP_GIFT_ADD_PAYMENT)
  }, [])

  const amountPer = getAmountPer(values.amount, values.otherAmount)
  const total = amountPer * actionableMembers.length
  return (
    <>
      <DialogContent>
        <List>
          <ListItem>
            <ListItemText>Gift recipients</ListItemText>
            <ListItemSecondaryAction>{actionableMembers.length}</ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText>Gift amount</ListItemText>
            <ListItemSecondaryAction>
              {formatCentsToPrettyDollars(amountPer)}
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primaryTypographyProps={{ className: classes.bold }}>Total</ListItemText>
            <ListItemSecondaryAction className={classes.bold}>
              {formatCentsToPrettyDollars(total)}
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onBack}>Back</Button>
        <ButtonSubmit color="primary" variant="contained" submitting={submitting}>
          Purchase
        </ButtonSubmit>
      </DialogActions>
      {error && <Alert color="error">{error}</Alert>}
    </>
  )
}

export default StepGiftPayment
